export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f07b10f034b0fdd320f2491d462165edda9ffd36d&name=fetchTypeahead!'